import "../../css/emailTemplate.css";
import "../../css/WebchatBrandingPage.css";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { brandingElementsFetchedFromServer, brandingElementsSavedToServer } from 'store/actions/WebchatBrandingElementsAction';
import { systemConfigurationFetchedFromServer } from 'store/actions/SystemConfigurationAction';

import { useActiveCompanyData } from "hooks/CompanyHooks";

import { Spin,Divider, message,  Button, Popover, Row } from "antd";
import { fetchSystemConfiguration, getBrandingElementsByCustomerExtUuid, saveBrandingElements } from "apiService/RESTApi";

import WebchatBrandingTabMenu from "../../Components/Webchat/WebchatBrandingTabMenu";
import TimothyPwaIFrame from "../../Components/Webchat/TimothyPwaIFrame"
import WebchatSaveButton from "../../Components/Webchat/WebchatSaveButton";
import WebchatTabs from "../../Components/Webchat/WebchatTabs";
import BlockNavWithUnsavedChangesModal from "./../../Components/Navigation/BlockNavWithUnsavedChangesModal.js"
import SkeletonBlock from "./../../commons/SkeletonBlock.js";
import WebchatPreviewButtonPopover from "Components/Webchat/WebchatPreviewButtonPopover";
import validateSubdomain from "../../utility/validateSubdomain";

export default function WebchatBrandingPage() {

  /**
   - Finish updating store use on all tabs
   - Saving animation to last the entire save process, give a toast when finished
   -
   - FUTURE: apply / save button css needs help (currently very different than the form page)
   - FUTURE: Update the page css to match form builder better in general
   - FUTURE: Implement grey on on save
   - FUTURE: implement skeletons on loading
   - FUTURE: Email template page - make components
   - EXTRA: can you make use of components to make the pages look like the form editor
   */


  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);
  const { serverState, previewState } = useSelector((state) => state.WebchatBrandingElementsReducer);
  const [hasUnsavedChanges, setUnsavedChanges] = useState(false);

  const dispatch = useDispatch();
  const activeCompanyData = useActiveCompanyData();

  const fetchBrandingData = useCallback(async () => {
    const defaults = {
      favicon: 'https://app.blustream.io/favicon.png',
      homeScreenIcon: 'https://app.blustream.io/favicon.png',
      headerIcon: 'https://app.blustream.io/favicon.png',
      brandMessageIcon: 'https://app.blustream.io/favicon.png',
      pageTitle: 'Branding',
      appName: 'ChatStream',
      mainElementColor: '#e2ebf3',
      brandMessageBackgroundColor: '#e2ebf3',
      brandMessageTextColor: "#000",
      contactMessageBackgroundColor: '#124173',
      contactMessageTextColor: '#fff',
      buttonTextColor: "#000",
      FAQLink: "#",
      SupportLink: "#",
      ShopLink: "#",
    };

    // When the page loads, activeCompanyData is not yet set
    if(activeCompanyData.uuid === undefined) {
      return;
    }

    try {
      const brandingResponse = await getBrandingElementsByCustomerExtUuid(activeCompanyData.uuid);
      if(!brandingResponse.SubDomain) {
        alert("Branding SubDomain not present. Please contact support.");
      }

      const mergedResponse = { ...defaults, ...brandingResponse }; // Merge server data into defaults
      dispatch(brandingElementsFetchedFromServer(mergedResponse));

    } catch (error) {
      console.error("Error fetching branding elements:", error);
      dispatch(brandingElementsFetchedFromServer({}));
    }
  }, [activeCompanyData.uuid, dispatch]);

  const saveChanges = async () => {
    setIsSaving(true);
    const changesToSave = previewState;
        
    try {
        if (!changesToSave.hasOwnProperty("SubDomain") || changesToSave.SubDomain === null || changesToSave.SubDomain === undefined || changesToSave.SubDomain.trim() === "") {
            alert("Short App Name MUST NOT be empty or blank");
            throw new Error("SubDomain not provided");
        }

        const validateErrors = await validateSubdomain(changesToSave.SubDomain);
        if (validateErrors.length > 0) {
            message.error({
                content: (
                    <div>
                        <strong>Please fix the following:</strong>
                        <ul style={{marginTop: 8, paddingLeft: 20}}>
                            {validateErrors.map((msg, i) => (
                                <li key={i} style={{listStyleType: "disc"}}>{msg}</li>
                            ))}
                        </ul>
                    </div>
                ),
                duration: 2
            });
            setIsSaving(false);
            return;
        }

        let saveBrandingElementsResponse = await saveBrandingElements(activeCompanyData.uuid, changesToSave);

        if (saveBrandingElementsResponse && saveBrandingElementsResponse.SubDomain) {
          dispatch(brandingElementsSavedToServer(saveBrandingElementsResponse));
          console.log(`${changesToSave.type} settings updated successfully`);
          message.success(`Settings updated successfully`);
        } else {
          console.error(`Failed to save ${changesToSave.type}`);
          message.error(`Failed to save changes`);
        }

      } catch (error) {
          console.error(`Error updating ${changesToSave.type} settings:`, error);
          message.error(`Error updating ${changesToSave.type}`);
      }
      setIsSaving(false);
  }

  // TODO: Check a higher level in the code where to do this...
    useEffect(() => {
        fetchSystemConfiguration().then(response => {
            dispatch(systemConfigurationFetchedFromServer(response));
        });
    },[dispatch])

  // On Page Load
  useEffect(() => {
    setIsPageLoading(true);
    console.log("Fetching branding data...");
    fetchBrandingData().then(r => {
      setIsPageLoading(false);
    });
  }, [activeCompanyData.uuid, fetchBrandingData]);

  // Check for unsaved changes
  useEffect(() => {
    const checkUnsavedChanges = () => {
      const serverKeys = Object.keys(serverState || {});

      // Check if all key-value pairs are the same
      const hasDifferences = serverKeys.some(key => {
        return !previewState.hasOwnProperty(key) || serverState[key] !== previewState[key];
      });
      setUnsavedChanges(hasDifferences);
    };

    checkUnsavedChanges();
  }, [serverState, previewState]);

  const hidePreviewButtonPopover = () => {
    setIsPopUpVisible(false);
  };

  const togglePreviewButtonPopoverVisibility = (newVisible) => {
    setIsPopUpVisible(newVisible);
  };

  return (
      <div className="email-template-container">
        {/* Header Section */}

        <BlockNavWithUnsavedChangesModal
            hasUnsavedChanges={hasUnsavedChanges}
        />
        <div className="editor-header">
          <div className="editor-header-left">
            <h2><strong>ChatStream</strong></h2>
            <p className="subheading">Easily connect with your contacts in a web-based, mobile-enabled channel.</p>
          </div>
          <div className="editor-header-right">
            <WebchatSaveButton hasUnsavedChanges={hasUnsavedChanges} onSaveCallback={saveChanges} />
              <Popover
                content={
                  <WebchatPreviewButtonPopover
                    url={"https://" + previewState.SubDomain + ".myblustream.io"}
                    loading={false}
                    hide={hidePreviewButtonPopover}
                  />
                }
                trigger={"click"}
                placement="bottomRight"
                visible={isPopUpVisible}
              >
                <Button
                  key="4"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "12px 20px",
                    gap: "10px",
                    height: "40px",
                    borderRadius: "8px",
                    fontFamily: "Hellix",
                    fontStyle: "normal",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "19px",
                    color: "#124173",
                    borderColor: "#124173",
                  }}
                  onClick={togglePreviewButtonPopoverVisibility}
                >
                  Preview
                </Button>
              </Popover>
          </div>
        </div>
        <Divider style={{ marginTop: '20px' }} />
        <Spin spinning={isSaving} tip="Saving changes..." size="medium">
          <div className="main-container" >

            {/* Editor Section */}
            <div className="branding-editor-main-container">
              <div className="editor-container">
                {
                  isPageLoading ? (
                      <div style={{ background: "#fff", padding: 20 }}>
                        <Row justify="center" gutter={[20, 20]}>
                          <SkeletonBlock style={{ width: 250, height: 500 }} />
                        </Row>
                      </div>
                  ) : (
                      <TimothyPwaIFrame/>
                  )
                }
              </div>
            </div>
            {/* Right Menu */}
            <div className="templates-list-header-container ant-tabs-nav-wrap">
              {/* Tabs Header */}
              <WebchatTabs />
              {/* Tab Content */}
              <div className="template-list-container">
                {
                  isPageLoading ? (
                      <div style={{ background: "#inherit", padding: 20 }}>
                        <Row justify="center" gutter={[20, 20]}>
                          <SkeletonBlock style={{ height: 650 }} />
                        </Row>
                      </div>
                  ) : (
                      <WebchatBrandingTabMenu />
                  )
                }
              </div>
            </div>
          </div>
        </Spin>
      </div>
  );
}